import { track } from "@amplitude/analytics-browser";

interface ExploreEmptyStateProps {
  onNavigateHome: () => void;
}

export function ExploreEmptyState({ onNavigateHome }: ExploreEmptyStateProps) {
  return (
    <div className="flex flex-col justify-center items-center h-full gap-4 px-4">
      <span className="text-center text-gray-600 break-keep">
        우리 동네에서 마히팩을 구하고 첫번째 히어로가 되어보세요!
      </span>
      <div
        onClick={() => {
          track("찐후기 근처 매장 없을 때 팩 구매하러 가기 클릭");
          onNavigateHome();
        }}
        className="bg-primary text-white px-4 py-2 rounded-full"
      >
        <span className="text-md font-medium">팩 구매하러 가기</span>
      </div>
    </div>
  );
}
